const query = (id, isPreview) => `
{
  multiColumnGridWithTextOrLink(id: "${id}", preview: ${isPreview}){
    heading
    elementId
    variant
    textCardsCollection (limit:70) {
      items {
        title
        description
        image {
          internalTitle
          altText
          imageDesktop {
            title
            fileName
            url
            width
            height
          }
          imageMobile {
            title
            description
            contentType
            fileName
            size
            url
            width
            height
          }
        }
        video{
           internalTitle
              title
              youtubeVideoId
              isButtonBlack
              variant
              posterImage {
                altText
                imageMobile {
                  title
                  description
                  contentType
                  fileName
                  size
                  url
                  width
                  height
                }
                imageDesktop {
                  title
                  description
                  contentType
                  fileName
                  size
                  url
                  width
                  height
                }
              }
              isModal
              enableWatchLater
              isImageToggle
              isCareerPage
        }
        link {
          name
          url
          label
          title
          target
          scrollToElementId
          imageType
          gaEventClass
          gaEventLabel
          ariaLabel
          images{
            altText
            imageDesktop{
              url
             
            }
          }
        }
      }
    }
    multiRowTable{
      varient
      rowHeadingCollection{
        items{
          title
          shortDescription
        }
      }
      rowCardsCollection{
        items{
          column1{
            ...on ImageWithText{
              description
            }
          }
          column2{
            ...on ImageWithText{
              description
            }
          }
        }
      }
    }

    linksCollection (limit:50) {
      items {
        title
        description
        variant
        linksCollection {
          items {
            __typename ...on Link {
              label
              title
              scrollToElementId
              url
              target
              gaEventClass
              gaEventLabel
            }
          }
        }
      }
    }
  }
}
`
module.exports = { query }
